<template>
  <div class="paginationDoc">
    <div class="paginationDoc_wrapper"></div>
    <pagination 
      @change-page="changePage"
      :max-page="getMaxPage"
      :selected-page="currentPage"
    />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'

export default {
  name: 'adx-pagination-doc',
  components: {
    Pagination
  },
  data () {
    return {
      currentPage: 1,
      maxDataEachPage: 5,
      maxData: 50
    }
  },
  methods: {
    changePage (selected) {
      this.$data.currentPage = selected;
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      history.pushState(null, null, '?page=' + selected);
    },
    getData(data_query) {
      try {
        (async () => {
          this.$data.loading = true;
          let data = await device.all(data_query);
          this.prepareData(data);
        })();
      } catch (err) {
        
      }
    },
  },
  computed: {
    getMaxPage() {
      return Math.ceil(this.getMaxData / this.$data.maxDataEachPage);
    },
    getMaxData() {
      return this.$data.maxData;
    },
  }
}
</script>

<style lang="sass" scoped>
@import './index.scss';
</style>

